import { Button, Space } from "antd";
import React from "react";
import IndexRowGroups from "./IndexRowGroups";
import { MinusCircleFilled } from "@ant-design/icons";

const getcellStyle = (index) => {
  return index === 0 ? { width: 50, paddingTop: 8 } : { width: 50 };
};

export default function IndexRow(props) {
  // console.log(props,props.selectedCols.filter(el=>el.type===1),'props 123')
  // .includes(rt.uniqueId)
  return (
    <>
      {/* <Space direction="horizontal"> */}
      <IndexRowGroups
        list={props.list.filter((rt) =>
          props.selectedCols
            .filter((el) => el.type === 1)
            .map((el) => el.uniqueId)
            .includes(rt.uniqueId)
        )}
        indexOptions={props.indexOptions}
        updateDataRecord={props.updateDataRecord}
        rowIndex={props.rowIndex}
        type={1}
        getIndexOptions={props.getIndexOptions}
      />
      <td
        style={{
          ...getcellStyle(props.rowIndex),
          borderRight: "1px solid rgba(0, 0, 0, 0.65)",
        }}
      ></td>
      <IndexRowGroups
        list={props.list.filter((rt) =>
          props.selectedCols
            .filter((el) => el.type === 2)
            .map((el) => el.uniqueId)
            .includes(rt.uniqueId)
        )}
        indexOptions={props.indexOptions}
        updateDataRecord={props.updateDataRecord}
        rowIndex={props.rowIndex}
        type={2}
        remove={props.remove}
        getIndexOptions={props.getIndexOptions}
      />
      <td style={getcellStyle(props.rowIndex)}>
        <Button
          onClick={() => props.remove(props.rowIndex)}
          type="link"
          style={{ color: "rgba(0, 0, 0, 0.65)" }}
          icon={<MinusCircleFilled />}
        ></Button>
      </td>
      {/* </Space> */}
    </>
    // <IndexRowGroups list={props.list}/>
  );
}
